import React from 'react';
import {observer} from 'mobx-react';
import {PreviousMeetingsWidgetProps} from "../models/previous-meetings-widget.props";
import {PreviousMeetingsWidgetUsLayoutPartialGameViewModel} from "../models/previous-meetings-widget.us-layout.partial-game.view-model";
import styles from "../styles/previous-meetings-widget.match-row.module.scss";
import classNames from "classnames";

export class PreviousMeetingsWidgetMatchRowDateProps extends PreviousMeetingsWidgetProps {
  item: PreviousMeetingsWidgetUsLayoutPartialGameViewModel;
}

export const PreviousMeetingsWidgetMatchRowDate = observer(({date, className}: PreviousMeetingsWidgetMatchRowDateProps) => {
  return (<div className={classNames(styles.secondary_text, styles.date_text, className)}>
      {date}
    </div>
  )
});
